import { atom } from "jotai";

export const mobileHeaderHeightAtom = atom<number>(106);
export const isNewHeaderAtom = atom<boolean>(false);